import { useLayoutEffect as w, useEffect as h, useState as s, useCallback as t } from "react";
import { u as p } from "./use-resize-observer-C4bVmnEB.js";
import { u as g } from "./use-merge-refs-DEJnLwh4.js";
const y = typeof window < "u" ? w : h, R = [void 0, null, null], v = () => {
  const [i, r] = s(null), [e, u] = s(null), f = t((o) => {
    u(o);
  }, []), n = t(() => {
    typeof window > "u" || window.requestAnimationFrame(() => {
      if (e) {
        const { width: o, height: l, x: a, y: m } = e.getBoundingClientRect();
        r({
          height: l,
          scrollHeight: e.scrollHeight,
          scrollWidth: e.scrollWidth,
          width: o,
          x: a,
          y: m
        });
      }
    });
  }, [e]);
  y(n, [n]);
  const [c] = p(n), d = g(f, c);
  return typeof window > "u" ? R : [d, i, e];
};
export {
  y as a,
  v as u
};
//# sourceMappingURL=use-dimensions-CSpaxs3M.js.map
